export var Tenants = ["Wisegaming"];
